import React, { useCallback, useEffect, useState } from 'react';
import { Virtual } from 'swiper/modules';
// Swiper base CSS comes from the same modules the source surface
// uses; importing here keeps the swiper-overlay / swiper-container
// global utility classes loaded inside the new ActionWindows tree.
import 'swiper/css';
import 'swiper/css/pagination';
import { Swiper, SwiperSlide } from 'swiper/react';

import { OVERLAYS_URL } from '../../../Settings';
import { getTextureUrl } from '../../TwoD/Common/TextureTools';

import '../../TwoD/Components/Controls/Actions/action-scroller.css';
import './ActionInventory.css';

// ActionInventory — verbatim port of LodgingSelector. Wraps the
// Swiper in an anchor div and renders an `<img className="swiper-
// overlay">` over it. Highlight state is local: listens for
// 'highlight-lodging-event' / 'clear-lodging-highlight-event' on
// `window`. Clicking a highlighted slot fires the highlight
// payload's callback with the swiper.clickedIndex and clears
// local highlight state.
export function ActionInventory({ gamePlayerData }) {
    const [highlight, setHighlight] = useState(false);
    const [highlightedIndexes, setHighlightedIndexes] = useState([]);
    const [lodgingCallback, setLodgingCallback] = useState(null);

    const resetLodging = useCallback(() => {
        setHighlight(false);
        setHighlightedIndexes([]);
        setLodgingCallback(null);
    }, []);

    useEffect(() => {
        const highlightEvent = (e) => {
            setHighlight(true);
            setHighlightedIndexes(e.detail.indexes || []);
            // Store the raw function. useState's functional-set
            // overload means we have to wrap it.
            setLodgingCallback(() => e.detail.callback);
        };
        window.addEventListener(
            'highlight-lodging-event', highlightEvent);
        window.addEventListener(
            'clear-lodging-highlight-event', resetLodging);
        return () => {
            window.removeEventListener(
                'highlight-lodging-event', highlightEvent);
            window.removeEventListener(
                'clear-lodging-highlight-event', resetLodging);
        };
    }, [resetLodging]);

    const onClick = (swiper) => {
        if (highlight) {
            if (lodgingCallback) {
                lodgingCallback(swiper.clickedIndex);
                resetLodging();
            }
        }
    };

    const lodging = (gamePlayerData
        && Array.isArray(gamePlayerData.lodging))
        ? gamePlayerData.lodging
        : [null, null, null, null, null, null];

    return (
        <div className={'action-inventory'}
             data-testid={'action-inventory'}>
            <div className={'action-inventory-container'}>
                <div className={'action-inventory-swiper-container'}>
                    <Swiper slidesPerView={6}
                            spaceBetween={0}
                            freeMode={true}
                            grabCursor={true}
                            modules={[Virtual]}
                            onClick={onClick}
                            className={'action-scroller-swiper'}>
                        {lodging.map((gridItem, index) => (
                            <SwiperSlide key={'gi-' + index}
                                         virtualIndex={index}>
                                <div data-testid={
                                        'action-inventory-slot'}
                                     data-slot-index={index}
                                     data-tname={gridItem || undefined}>
                                    <img src={getTextureUrl(gridItem)}
                                         alt={'room'}
                                         className={
                                             'action-inventory-image'}/>
                                    {highlightedIndexes.includes(index)
                                        && (
                                        <div className={
                                                'action-inventory-'
                                                + 'highlighter'}
                                             data-testid={
                                                 'action-inventory'
                                                 + '-highlight'}/>
                                    )}
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
                <img src={OVERLAYS_URL
                        + 'LodgingOverlay-1080x210.png'}
                     alt={'action'}
                     data-testid={'action-inventory-overlay'}
                     className={'swiper-overlay'}/>
            </div>
        </div>
    );
}

export default ActionInventory;
